// Maps backend HTTPException detail strings (matched verbatim) to i18n keys.
// Backend sources: backend/auth.py (password strength), backend/server.py (login, reset links).
// Keep in sync with those detail strings.
const DETAIL_TO_KEY = {
  "Invalid credentials": "errInvalidCredentials",
  "Password must be at least 8 characters": "errPasswordMinLength",
  "Password must contain at least one letter": "errPasswordLetter",
  "Password must contain at least one digit or special character": "errPasswordDigit",
  "This password is too common. Please choose a stronger one.": "errPasswordCommon",
  "Invalid or expired reset link": "errResetLinkInvalid",
  "Reset link has expired. Please request a new one.": "errResetLinkExpired",
};

export function localizeApiError(detail, t) {
  const key = DETAIL_TO_KEY[detail];
  return key ? t(key) : (detail || t("errGeneric"));
}
